export default __webpack_public_path__ + "static/media/eip-logo.86f96120.png";